import { createSharedState } from '@versita/frontend/react-utils';
import {
  BrowserAuthError,
  EventType,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
type AuthError = {
  error: Error;
  errorCode: string;
  eventType: EventType;
  scopes: string[];
};

export const useAuthError = createSharedState<AuthError | null>();

export const useHandleAuthError = () => {
  const [, setAuthError] = useAuthError();

  return (error: Error, eventType: EventType, scopes: string[]) => {
    if (
      error instanceof BrowserAuthError ||
      error instanceof InteractionRequiredAuthError
    ) {
      setAuthError({ error, errorCode: error.name, eventType, scopes });
    }
  };
};
